/**
 * Created by staffanrantzow on 21/09/16.
 */

export default class AgreementEntity {

  constructor (
    id,
    createdAt,
    invoiceId,
    text,
    typeId,
    pdfUrl
  ) {
    this.id = id;
    this.createdAt = createdAt;
    this.invoiceId = invoiceId;
    this.text = text;
    this.typeId = typeId;
    this.pdfUrl = pdfUrl;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/agreements/agreement-entity.js
 **/